import React from 'react';
import Icons from '@/const/icons';
import { Icon } from '@/components/common';
import clsx from 'clsx';

interface Props {
	className?: string;
}

export const Quote: React.FC<Props> = ({ className }) => {
	return (
		<div
			className={clsx(
				'rounded-full bg-green-base w-16 h-16 flex items-center justify-center',
				className
			)}
		>
			<Icon src={Icons.quoteDown} className="!size-8 text-white" />
		</div>
	);
};
